import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import { useDeleteWorkout } from 'hooks/workout';
import { WorkoutList } from 'types';
import notificationHandler from 'utils/notifications';

const ModalWorkoutDelete = ({
  opened,
  workout,
  handleClose,
}: {
  opened: boolean;
  handleClose: () => void;
  workout: WorkoutList | null;
}): JSX.Element => {
  const { mutate, isLoading } = useDeleteWorkout();
  const { successNotification, errorNotification } = notificationHandler();

  const handleDelete = (): void => {
    if (!workout?.workoutId) return;
    mutate(workout.workoutId, {
      onSuccess: () => {
        successNotification('Workout deleted', `${workout.name} has been deleted successfully.`);
      },
      onError: error => {
        const errorMessage = error.response?.data?.message || 'Failed to delete workout';
        errorNotification('Delete failed', errorMessage);
      },
      onSettled: () => {
        handleClose();
      },
    });
  };

  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete Workout?</Title>}
      size='auto'
    >
      <Stack>
        <Text>
          Are you sure you want to delete <strong>{workout?.name ?? 'this workout'}</strong>?
        </Text>
        <Text color='dimmed'>This action cannot be undone.</Text>
        <Group position='right'>
          <Button variant='subtle' onClick={handleClose}>
            Cancel
          </Button>
          <Button onClick={handleDelete} color='red' loading={isLoading} disabled={!workout?.workoutId}>
            Delete Permanently
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalWorkoutDelete;
